import React from 'react';
import PropTypes from 'prop-types';
import './TripBoardHit.less';

function TripBoardHit({
    thumbnails,
    tripBoardTitle,
    ...rest
}) {
    return (
        <div {...rest} className="react-trip-board-button__hit">
            <h6 className="react-trip-board-button__hit-title" >{tripBoardTitle}</h6>
            <div className="react-trip-board-button__hit-images">
                <div className="react-trip-board-button__hit-image-1" style={{backgroundImage: thumbnails[0] ? `url(${thumbnails[0]})` : 'none'}} />
                <div className="react-trip-board-button__hit-image-2" style={{backgroundImage: thumbnails[1] ? `url(${thumbnails[1]})` : 'none'}} />
                <div className="react-trip-board-button__hit-image-3" style={{backgroundImage: thumbnails[2] ? `url(${thumbnails[2]})` : 'none'}} />
                <div className="react-trip-board-button__hit-image-4" style={{backgroundImage: thumbnails[3] ? `url(${thumbnails[3]})` : 'none'}} />
            </div>
        </div>
    );
}

TripBoardHit.propTypes = {
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    tripBoardTitle: PropTypes.string
};

TripBoardHit.defaultProps = {
    thumbnails: [],
    tripBoardTitle: ''
};

export default TripBoardHit;
